/*
 * Purpose: Express vs Guided compose mode — how a running Mission proceeds
 * Last modified: 2026-06-27 | Agent
 * Completeness: 95
 */
import type { IntentInterpretation } from './intentInterpretation';
import type { ComposeMode } from './missionTypes';
import type { PlanReadinessReport } from './planReadiness';
import { hasResolvedSecret } from '@/lib/resolveSecret';

export function resolveInitialComposeMode(interpretation: IntentInterpretation): ComposeMode {
  if (interpretation.gaps.length > 0 && interpretation.suggestedComposeMode === 'express') {
    return 'guided';
  }
  return interpretation.suggestedComposeMode;
}

export function shouldSwitchToGuided(
  readiness: PlanReadinessReport | null,
  interpretation?: IntentInterpretation | null
): boolean {
  if (readiness && !readiness.allRequiredReady) return true;
  if (interpretation?.gaps && interpretation.gaps.length > 2) return true;
  if (interpretation?.needsOpenAi && !hasResolvedSecret('OPENAI_API_KEY')) return true;
  return false;
}

export function shouldSwitchToExpress(
  readiness: PlanReadinessReport | null,
  interpretation?: IntentInterpretation | null
): boolean {
  if (!readiness?.allRequiredReady) return false;
  if (interpretation?.matchedTemplateHint) return true;
  if (interpretation?.confidence && interpretation.confidence >= 0.8) return true;
  return false;
}

export function composeModeLabel(mode: ComposeMode): string {
  return mode === 'express' ? 'Express' : 'Guided';
}

export function composeModeDescription(mode: ComposeMode): string {
  if (mode === 'express') {
    return 'Shortcut when outcome and setup are ready — confirm and run.';
  }
  return 'Full trail — interpret, plan, connect, dry-run, then approve.';
}
